<template>
  <div id="app"  v-cloak>
    <!-- <Header/> -->
    <router-view></router-view>
    <!-- <Footer v-show="$route.meta.show"/> -->
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="less">
[v-cloak] {
  display: none !important;
}
</style>
